import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=4b20518f&scoped=true&"
import script from "./DurationField.vue?vue&type=script&lang=js&"
export * from "./DurationField.vue?vue&type=script&lang=js&"
import style0 from "./DurationField.vue?vue&type=style&index=0&id=4b20518f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20518f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
